/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuplacepicker2Inputs */

const en_menuplacepicker2 = /** @type {(inputs: Menuplacepicker2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place`)
};

const de_menuplacepicker2 = /** @type {(inputs: Menuplacepicker2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "Place" |
*
* @param {Menuplacepicker2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuplacepicker2 = /** @type {((inputs?: Menuplacepicker2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuplacepicker2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuplacepicker2(inputs)
	return de_menuplacepicker2(inputs)
});
export { menuplacepicker2 as "menuPlacePicker" }